var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { observer } from 'mobx-vue';
import { Component, Vue } from 'vue-property-decorator';
import Content from './content.vue';
import ViewRight from './views/rightContentRender.vue';
let default_1 = class extends Vue {
    constructor() {
        super(...arguments);
        this.Layout = {
            menus: [],
            openKeys: [],
            collapsed: false,
            autoHideHeader: false,
            fixedHeader: true,
            fixSiderbar: true,
            query: {},
            layout: 'sidemenu',
            contentWidth: 'Fluid',
            theme: 'dark',
            isMobile: false,
            i18nRender: (event) => {
                return event;
            },
            handleMediaQuery: (event) => { },
            handleCollapse: (event) => {
                this.Layout.collapsed = event;
                if (this.Layout.collapsed) {
                    this.Layout.openKeys = undefined;
                }
                else {
                    this.Layout.openKeys = lodash.map(this.directory, 'name');
                }
            },
        };
    }
    layoutMerge(AppSettings) {
        return lodash.merge({}, this.Layout, AppSettings);
    }
    get languages() {
        return lodash.keys(this.$i18n.messages);
    }
    get directory() {
        // 获取基本路由
        const routes = lodash.map(this.$router.options.routes, (item) => {
            const splits = lodash.split(item.name, '-');
            const len = lodash.size(splits);
            let headKey = lodash.head(splits);
            let parent = len > 1 ? headKey : 'root';
            if (lodash.includes(['smb', 'isg', 'rel'], headKey) && len > 1) {
                headKey = lodash.get(splits, '[1]');
                parent = len > 2 ? headKey : 'root';
            }
            return lodash.assign({ len, parent }, item);
        });
        const directory = lodash.map(lodash.uniq(lodash.map(routes, 'parent')), (item) => {
            return {
                name: item,
                children: lodash.orderBy(lodash.filter(routes, ['parent', item]), 'name', 'asc'),
            };
        });
        return directory;
    }
    onClickLeft() { }
    onClickRight() { }
    toMenu(page) {
        const meta = {
            icon: 'menu-fold',
        };
        if (lodash.get(page, 'component.extendOptions.head')) {
            lodash.assign(meta, lodash.get(page, 'component.extendOptions.head'));
        }
        else {
            lodash.assign(meta, { title: this.$t(page.name) });
        }
        return {
            to: { path: page.path || page.name },
            path: page.path || page.name,
            name: page.name,
            meta: meta,
            children: page.children && lodash.map(page.children, this.toMenu),
        };
    }
    mounted() {
        if (this.AppConfig.ChildrenPage) {
            return;
        }
        const directory = this.directory;
        this.Layout.openKeys = lodash.map(directory, 'name');
        const menus = lodash.map(lodash.concat(lodash.differenceBy(lodash.get(lodash.find(directory, ['name', 'root']), 'children', []), [{ name: 'index' }], 'name'), lodash.differenceBy(directory, [{ name: 'root' }], 'name')), this.toMenu);
        this.Layout.menus = lodash.cloneDeep(menus);
        console.log('LENG ~ extends ~ mounted ~ this.Layout.menus', menus);
    }
    updated() { }
    destroyed() { }
};
default_1 = __decorate([
    observer,
    Component({
        components: {
            ViewRight,
            Content,
        },
    })
], default_1);
export default default_1;
